export default "__VITE_ASSET__rALBisjv__"